import React from "react";
import { useFormik } from "formik";
import { Row,Card,Col,Form,Button } from "react-bootstrap"; 
import { useDispatch,useSelector } from "react-redux";

import { convertUtcToLocal } from "../../utils/functions";
import { IReduxState } from "../../utils/types";
import ListComponent from "./ListComponent";
import { GetUsageReportAction } from "../../Redux/Actions/ReportsActions";


const UsageReport = () => {
    const reportData = useSelector((state: IReduxState) => state.Reports );
    const dispatch = useDispatch();

    let periodList = ['Today', 'Yesterday', 'Last 7 days', 'Custom'];

    let initialValues = {
        period: 'Today',
        startDate: convertUtcToLocal(new Date(),'YYYY-MM-DD'),
        endDate: convertUtcToLocal(new Date(),'YYYY-MM-DD'),
    };

    const formik:any = useFormik({
        initialValues: initialValues ,
        onSubmit: (value, { resetForm }) => { 
            dispatch(GetUsageReportAction(value))
            // resetForm({
            //     values: initialValues
            // })
        }
    });

    const handlePeriodChange = (e:any)=>{ 
        let currentDate = new Date();
        let startDt =  convertUtcToLocal(currentDate,'YYYY-MM-DD');
        let endDt;
        if(e.target.value==='Yesterday'){
            let previousDate = new Date(currentDate);
            previousDate.setDate(currentDate.getDate() - 1);
             
            startDt =  convertUtcToLocal(previousDate,'YYYY-MM-DD');
            endDt = startDt;
            formik.setFieldValue("startDate",startDt);
            formik.setFieldValue("endDate",endDt);
        }else if(e.target.value==='Today'){ 
            endDt = startDt;
            formik.setFieldValue("startDate",startDt);
            formik.setFieldValue("endDate",endDt);
        }else if(e.target.value==='Last 7 days'){ 
            let previousDate = new Date(currentDate);
            previousDate.setDate(currentDate.getDate() - 7); 
            endDt = startDt;
            startDt =  convertUtcToLocal(previousDate,'YYYY-MM-DD');
            formik.setFieldValue("startDate",startDt);
            formik.setFieldValue("endDate",endDt);
        }
        formik.setFieldValue("period",e.target.value);
    }

    const onDateChangePeriodUpdate = ()=>{ 
        if(formik.values.period && formik.values.period !== 'Custom' ){
            formik.setFieldValue("period",'Custom');
        }
    } 
 
    return (
        <>
            <Row className="d-flex justify-content-center mt-3">
                <Row>
                    <h3 className="module_title">
                        Usage Report
                    </h3>
                </Row>
            </Row>

            <Card>
                <Row style={{padding:"15px"}}>
                    <Row>
                        <Col md={6}>
                            <Form.Group
                                as={Row}
                                className="mb-3"
                                style={{ display: "flex", alignItems: "center" }}
                            >
                                <Form.Label
                                    column
                                    lg={2}
                                    htmlFor="simpleinput"
                                    id="smallerFontSize"
                                >
                                    Period
                                </Form.Label>
                                <Col lg={10}>
                                    <Form.Select
                                        name="period"
                                        value={formik.values.period}
                                        onChange={handlePeriodChange}
                                        onBlur={formik.handleBlur}
                                        className="fsz-875rem "
                                    >
                                        {periodList.map((item: string) => (
                                            <option key={item} value={item}>
                                                {item}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group
                                as={Row}
                                className="mb-3"
                                style={{ display: "flex", alignItems: "center" }}
                            >
                                <Form.Label
                                    column
                                    lg={2}
                                    htmlFor="simpleinput"
                                    id="smallerFontSize"
                                >
                                    Start Date
                                </Form.Label>
                                <Col lg={10}>
                                    <Form.Control 
                                        type="date" 
                                        placeholder='dd-mm-yyyy' 
                                        name="startDate" 
                                        value={formik.values.startDate}  
                                        onChange={(e)=>{
                                            onDateChangePeriodUpdate();
                                            formik.setFieldValue("startDate", e.target.value)
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group
                                as={Row}
                                className="mb-3"
                                style={{ display: "flex", alignItems: "center" }}
                            >
                                <Form.Label
                                    column
                                    lg={2}
                                    htmlFor="simpleinput"
                                    id="smallerFontSize"
                                >
                                    End Date
                                </Form.Label>
                                <Col lg={10}>
                                    <Form.Control 
                                        type="date" 
                                        placeholder='dd-mm-yyyy' 
                                        name="endDate"  
                                        value={formik.values.endDate}
                                        onChange={(e)=>{
                                            onDateChangePeriodUpdate();
                                            formik.setFieldValue("endDate", e.target.value)
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                    <Col>
                        <Button
                            style={{ marginLeft: "0", fontWeight: "700" }}
                            variant="primary"
                            onClick={() => {
                                formik.handleSubmit();
                            }}
                        >
                            Apply
                        </Button> 
                    </Col>
                </Row>
                </Row>
            </Card>

            <Card>
                <Row style={{padding:"15px"}}>
                    <ListComponent usageReportData={reportData?.usageReportData?reportData?.usageReportData:[]} />   
                </Row>
            </Card>

        </>
    );
};

export default UsageReport;